// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__39jVT","dragIcon":"Choice_dragIcon__1JCS5","left":"Choice_left__24JLr","input":"Choice_input__1duQX"};